module.exports = __webpack_public_path__ + "img/Jay.4d38589b.png";